import * as actions from "../appointments/data-layer/appointments/actions.js";
const PAGE_VIEW = "my-account/datalayer/page-view";
const PROFILE_EDIT_SUCCESS = "my-account/datalayer/profile-edit-success";
const PROFILE_EDIT_ERROR = "my-account/datalayer/profile-edit-error";
const PASSWORD_CHANGE_SUCCESS = "my-account/datalayer/password-change-success";
const PASSWORD_CHANGE_ERROR = "my-account/datalayer/password-change-error";
const profileEditSuccess = () => ({
  type: PROFILE_EDIT_SUCCESS
});
const profileEditError = (error) => ({
  type: PROFILE_EDIT_ERROR,
  payload: {
    error
  }
});
export {
  actions as Appointments,
  PAGE_VIEW,
  PASSWORD_CHANGE_ERROR,
  PASSWORD_CHANGE_SUCCESS,
  PROFILE_EDIT_ERROR,
  PROFILE_EDIT_SUCCESS,
  profileEditError,
  profileEditSuccess
};
//# sourceMappingURL=actions.js.map
